import React from 'react';
import styled from 'styled-components';

const SubtleTxt = styled.span`
  color: ${props => props.theme?.subtleText?.color || '#9B9B9B'};
  font-size: ${props => props.theme?.subtleText?.fontSize};
  font-style: ${props => props.theme?.subtleText?.fontStyle || 'italic'};
`;

export default function SubtleText({text, color}) {
  return <SubtleTxt style={{color}}>{text}</SubtleTxt>
}
